import { render, staticRenderFns } from "./BrandHero.vue?vue&type=template&id=684f0b2e&scoped=true&"
import script from "./BrandHero.vue?vue&type=script&lang=ts&"
export * from "./BrandHero.vue?vue&type=script&lang=ts&"
import style0 from "./BrandHero.vue?vue&type=style&index=0&id=684f0b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f0b2e",
  null
  
)

export default component.exports